module.exports = __webpack_public_path__ + "img/p101.16618a96.jpg";